import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  HostListener,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-sorting-dropdown',
  templateUrl: './sorting-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SortingDropdown implements OnInit {
  @Input() disabled = false;
  @Output() selectedOptionChange = new EventEmitter<string>();

  selectedOption = 'DESC';
  isOpen = signal(false);

  optionList = [
    { value: 'DESC', viewValue: 'Top 10 Performing' },
    { value: 'ASC', viewValue: 'Bottom 10 Performing' },
  ];

  get selectedLabel(): string {
    return (
      this.optionList.find((o) => o.value === this.selectedOption)?.viewValue ??
      ''
    );
  }

  ngOnInit(): void {
    this.selectedOptionChange.emit(this.selectedOption);
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.disabled) this.isOpen.update((v) => !v);
  }

  select(value: string, event: MouseEvent): void {
    event.stopPropagation();
    this.selectedOption = value;
    this.isOpen.set(false);
    this.selectedOptionChange.emit(value);
  }

  @HostListener('document:click')
  close(): void {
    this.isOpen.set(false);
  }
}
